import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { WorkshopContext } from "../contexts/workshop.context";

import { Button, ScreenBottom, VerticalSpace } from "../components/workshop";
import { WordCloudRenderer } from "../components/insights";

import { defaultRoles } from "../util/workshop.util";
import { getPreviousRoute, getNextRoute } from "../util/general.util";
import { parseWordsList, skillsPillasCloudColors } from "../util/wordcloud.util";

const Task10b = () => {
  const [skillsWords, setSkillsWords] = useState([]);

  const {
    socket,
    user: { id, role } = {},
    workshopDetails: { platform } = {}
  } = useContext(WorkshopContext);

  const { t } = useTranslation();

  useEffect(() => {
    socket.on("task10", (data) => {
      const { skillsSubmissions: skillsSubmissionsServer } = data;

      try {
        const parsedSkillsWords = parseWordsList(skillsSubmissionsServer, "skills");
        setSkillsWords(parsedSkillsWords);
      } catch (error) {
        console.log(error);
      }
    });

    socket.emit("task10");
  }, [id]);

  const handleBack = () => {
    const previousRoute = getPreviousRoute("/task-10/b", platform);
    socket.emit("navigate", previousRoute);
  };

  const handleNext = () => {
    const nextRoute = getNextRoute("/task-10/b", platform);
    if (nextRoute === "end_workshop") {
      socket.emit("endWorkshop");
    } else {
      socket.emit("navigate", nextRoute);
    }
  };

  return (
    <div className={"flex flex-col gap-4"}>
      <div className="flex gap-4 items-center justify-start">
        <h1
          dangerouslySetInnerHTML={{ __html: t("mtParticipantsActivityTenB.heading") }}
          className="text-5xl font-medium font-righteous text-gray-250"
        />
      </div>
      {role !== defaultRoles.moderator && (
        <>
          <p
            dangerouslySetInnerHTML={{ __html: t("mtParticipantsActivityTenB.subheading") }}
            className="text-xl text-gray-100"
          />
        </>
      )}

      {/* TASK 10b */}
      {role !== defaultRoles.moderator && (
        <div className="mt-8">
          <h2
            dangerouslySetInnerHTML={{ __html: t("mtParticipantsActivityTenB.heading1") }}
            className="text-2xl font-bold text-gray-250"
          />
          <p
            dangerouslySetInnerHTML={{
              __html: t("mtParticipantsActivityTenB.description1")
            }}
            className="text-xl text-gray-100"
          />

          <VerticalSpace />
        </div>
      )}

      {role === defaultRoles.moderator && (
        <>
          <h2
            dangerouslySetInnerHTML={{ __html: t("mtParticipantsActivityTenB.headingSkills") }}
            className="text-2xl font-bold text-gray-250"
          />
          <p
            dangerouslySetInnerHTML={{
              __html: t("mtParticipantsActivityTenB.headingSkillsSub")
            }}
            className="text-xl text-gray-100"
          />
        </>
      )}

      <WordCloudRenderer
        id={"skills"}
        words={skillsWords}
        width={1500}
        height={1500}
        border="0.5px solid var(--MT-black, #454444)"
        backgroundColor="#fff"
        colorFunction={() => skillsPillasCloudColors.skillsWords}
        weightFactorFormula={(size) => size * 1.5}
      />

      {role !== defaultRoles.participant && (
        <ScreenBottom helperText={t("navigationHelperText.task10b")}>
          <Button text={t("buttonBack")} onClick={handleBack} type="outline" />
          <Button text={t("buttonNext")} onClick={handleNext} />
        </ScreenBottom>
      )}
    </div>
  );
};

export default Task10b;
